export const CONFIRMATION_DIALOG_TYPES = {
    EMPTY_PROJECT: 'EMPTY_PROJECT',
    EMPTY_HOME_PAGE: 'EMPTY_HOME_PAGE',
}

export  const AUTO_SAVE_INTERVAL = 20000